import { useState } from 'react';
import { Box, Stepper, Step, StepLabel, Typography } from '@mui/material';
import LoadUploadStep from './LoadUploadStep.jsx';
import AssetQuestionnaireStep from './AssetQuestionnaireStep.jsx';
import MetaTuningStep from './MetaTuningStep.jsx';
import PredictionTestStep from './PredictionTestStep.jsx';

const STEPS = ['Load Data', 'Site Assets', 'Meta Tuning', 'Prediction Test'];

export default function CalibrationWizard() {
  const [activeStep, setActiveStep] = useState(0);
  const [wizardState, setWizardState] = useState({
    load_8760_kw: null,
    quality: null,
    location: null,
    assets: null,
    tariff_selection: null,
    scenario_data: null,
    digital_twin_summary: null,
    tier1_config: null,
    tier2_config: null,
    explanations: null,
    site_profile: null,
    simulation_results: null,
  });

  const updateState = (updates) => setWizardState(prev => ({ ...prev, ...updates }));
  const handleNext = () => setActiveStep(prev => prev + 1);
  const handleBack = () => setActiveStep(prev => Math.max(0, prev - 1));

  // "Load from Project" skips steps 1 & 2 — goes straight to Meta Tuning
  const handleProjectLoaded = (data) => {
    updateState(data);
    setActiveStep(2); // Jump to Meta Tuning
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>Site Calibration</Typography>
      <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
        {STEPS.map(label => (
          <Step key={label}><StepLabel>{label}</StepLabel></Step>
        ))}
      </Stepper>

      {activeStep === 0 && (
        <LoadUploadStep
          onComplete={(data) => { updateState(data); handleNext(); }}
          onProjectLoaded={handleProjectLoaded}
        />
      )}
      {activeStep === 1 && (
        <AssetQuestionnaireStep
          load_8760_kw={wizardState.load_8760_kw}
          location={wizardState.location}
          onComplete={(data) => { updateState(data); handleNext(); }}
          onBack={handleBack}
        />
      )}
      {activeStep === 2 && (
        <MetaTuningStep
          scenario_data={wizardState.scenario_data}
          onComplete={(data) => { updateState(data); handleNext(); }}
          onBack={handleBack}
        />
      )}
      {activeStep === 3 && (
        <PredictionTestStep
          scenario_data={wizardState.scenario_data}
          tier1_config={wizardState.tier1_config}
          tier2_config={wizardState.tier2_config}
          onBack={handleBack}
        />
      )}
    </Box>
  );
}
